import { resolveFileOnBrowser } from '@/shared/utils/filesUtils'
import { stringify } from 'csv-stringify/sync'
import { z } from 'zod'

export function getHeadersFromZodSchema<TSchema extends z.ZodTypeAny>(schema: TSchema, prefix = ''): string[] {
    if (schema instanceof z.ZodObject) {
        return Object.entries(schema.shape).flatMap(([key, value]) =>
            getHeadersFromZodSchema(value as z.ZodTypeAny, prefix ? `${prefix}.${key}` : key)
        )
    }

    if (schema instanceof z.ZodArray) {
        return [prefix]
    }

    if (schema instanceof z.ZodOptional || schema instanceof z.ZodNullable) {
        return getHeadersFromZodSchema(schema.unwrap(), prefix)
    }

    if (schema instanceof z.ZodDefault) {
        return getHeadersFromZodSchema(schema._def.innerType, prefix)
    }

    return prefix ? [prefix] : []
}

export function buildCsvFromSchema<TSchema extends z.ZodTypeAny>(schema: TSchema): string {
    const headers = getHeadersFromZodSchema(schema)
    return stringify([], {
        header: true,
        columns: headers
    })
}

export function downloadCsvTemplateFromSchema<TSchema extends z.ZodTypeAny>(schema: TSchema, fileName: string) {
    const csv = buildCsvFromSchema(schema)
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })

    return resolveFileOnBrowser(blob, fileName, true)
}
